/* ─── JHN Suite — composants « liquid glass » ───────────────────────────────── */

.glass {
  background: var(--glass);
  -webkit-backdrop-filter: blur(22px) saturate(180%);
  backdrop-filter: blur(22px) saturate(180%);
  border: 1px solid var(--border);
  border-radius: var(--r-lg);
  box-shadow: var(--shadow-sm);
  position: relative;
}
/* liseré lumineux supérieur, signature « verre liquide » */
.glass::before {
  content: "";
  position: absolute; inset: 0; border-radius: inherit; pointer-events: none;
  background: linear-gradient(180deg, rgba(255,255,255,0.06), transparent 38%);
  -webkit-mask: linear-gradient(#fff, #fff); /* contient l'effet au panneau */
}

/* ── Boutons ── */
.btn {
  display: inline-flex; align-items: center; justify-content: center; gap: 8px;
  height: 40px; padding: 0 16px; border-radius: 99px; border: 1px solid var(--border);
  background: var(--glass); color: var(--text); font-size: 14px; font-weight: 560;
  cursor: pointer; white-space: nowrap; transition: background var(--dur) var(--ease),
    transform 0.12s var(--ease), border-color var(--dur) var(--ease), box-shadow var(--dur);
  -webkit-backdrop-filter: blur(14px) saturate(160%); backdrop-filter: blur(14px) saturate(160%);
}
.btn:hover { background: var(--glass-hover); border-color: var(--border-strong); }
.btn:active { transform: scale(0.97); }
.btn svg { width: 18px; height: 18px; }

.btn-primary {
  background: linear-gradient(180deg, var(--coral), var(--coral-600));
  color: #fff; border-color: transparent;
  box-shadow: 0 8px 20px -8px rgba(239,121,91,0.7);
}
.btn-primary:hover { background: linear-gradient(180deg, #f4866b, var(--coral)); border-color: transparent; }

.btn-ghost { background: transparent; border-color: transparent; -webkit-backdrop-filter: none; backdrop-filter: none; }
.btn-ghost:hover { background: var(--glass); }

.btn-icon { width: 40px; padding: 0; border-radius: 50%; }
.btn-sm { height: 32px; padding: 0 12px; font-size: 13px; }
.btn-sm.btn-icon { width: 32px; }
.btn[disabled] { opacity: 0.5; pointer-events: none; }

/* ── Champs ── */
.input, .search input, textarea.input {
  height: 40px; width: 100%; padding: 0 14px; border-radius: 12px;
  background: var(--glass); border: 1px solid var(--border); color: var(--text);
  font-size: 14px; outline: none; transition: border-color var(--dur), background var(--dur);
}
textarea.input { height: auto; padding: 10px 14px; resize: vertical; min-height: 80px; }
.input:focus { border-color: var(--coral); background: var(--glass-strong); }
.input::placeholder { color: var(--text-faint); }

.search { position: relative; display: flex; align-items: center; max-width: 460px; flex: 1; }
.search .search-ic { position: absolute; left: 14px; top: 50%; transform: translateY(-50%); width: 17px; height: 17px; color: var(--text-faint); pointer-events: none; display: flex; }
.search .search-ic svg { width: 17px; height: 17px; display: block; }
.search input { padding-left: 40px; height: 42px; border-radius: 99px; width: 100%; }

/* Sélecteur de rôle (partage) */
.role-select { height: 38px; padding: 0 10px; border-radius: 12px; background: var(--glass); border: 1px solid var(--border); color: var(--text); font-size: 13.5px; cursor: pointer; outline: none; }
.role-select:focus { border-color: var(--coral); }

/* Résultats de recherche (dropdown) */
.search-results { position: absolute; top: calc(100% + 8px); left: 0; right: 0; z-index: 250; max-height: 380px; overflow: auto;
  background: var(--glass-strong); border: 1px solid var(--border); border-radius: 16px; box-shadow: var(--shadow); padding: 6px;
  -webkit-backdrop-filter: blur(26px) saturate(180%); backdrop-filter: blur(26px) saturate(180%); }
.search-row { display: flex; align-items: center; gap: 10px; padding: 9px 10px; border-radius: 10px; cursor: pointer; }
.search-row:hover { background: var(--glass-hover); }
.search-row-ic { width: 28px; height: 28px; border-radius: 8px; display: grid; place-items: center; color: #fff; flex: none; }
.search-row-nm { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 14px; font-weight: 540; }
.search-row-ty { font-size: 12px; color: var(--text-faint); flex: none; }
.search-empty { padding: 16px; color: var(--text-faint); font-size: 14px; text-align: center; }

/* ── Sidebar ── */
/* Desktop : sidebar fondue dans le fond de l'app (pas de panneau / jointure). */
.sidebar {
  margin: 0; display: flex; flex-direction: column;
  padding: 18px 14px; gap: 6px; overflow: hidden;
  background: transparent; border: none; box-shadow: none;
}
.brand { display: flex; align-items: center; gap: 11px; padding: 6px 8px 14px; }
.brand img { width: 36px; height: 36px; border-radius: 9px; box-shadow: var(--shadow-sm); }
.brand b { font-size: 17px; letter-spacing: -0.02em; font-weight: 680; }
.brand span { color: var(--text-faint); font-weight: 500; font-size: 13px; }
.shell.collapsed .brand b, .shell.collapsed .brand span, .shell.collapsed .nav-item span,
.shell.collapsed .sb-section, .shell.collapsed .storage span { display: none; }
.shell.collapsed .nav-item { justify-content: center; padding: 11px; }

.new-btn { margin: 4px 2px 12px; }
.shell.collapsed .new-btn span { display: none; }

.sb-section { font-size: 11px; letter-spacing: 0.08em; text-transform: uppercase; color: var(--text-faint);
  padding: 14px 12px 6px; font-weight: 650; }
.nav-list { display: flex; flex-direction: column; gap: 2px; }
.nav-item {
  display: flex; align-items: center; gap: 12px; padding: 10px 12px; border-radius: 12px;
  color: var(--text-dim); font-size: 14.5px; font-weight: 530; cursor: pointer;
  transition: background var(--dur) var(--ease), color var(--dur); border: 1px solid transparent;
}
.nav-item:hover { background: var(--glass-strong); color: var(--text); }
.nav-item.active { background: var(--coral-soft); color: var(--coral); border-color: rgba(239,121,91,0.22); }
.nav-item svg { width: 19px; height: 19px; flex: none; }
.nav-item .count { margin-left: auto; font-size: 12px; color: var(--text-faint); }

.sb-spacer { flex: 1; }
.storage { padding: 12px; border-radius: 14px; background: var(--hairline); }
.storage .bar { height: 6px; border-radius: 99px; background: var(--border-strong); overflow: hidden; margin: 8px 0 6px; }
.storage .bar i { display: block; height: 100%; background: linear-gradient(90deg, var(--coral), #f4a78f); border-radius: 99px; }
.storage span { font-size: 12px; color: var(--text-faint); }

/* ── Topbar ── */
.topbar {
  display: flex; align-items: center; gap: 14px; padding: 0 22px 0 18px;
  border-bottom: 1px solid var(--hairline);
  -webkit-backdrop-filter: blur(20px) saturate(170%); backdrop-filter: blur(20px) saturate(170%);
  background: linear-gradient(180deg, var(--glass-strong), transparent);
}
.topbar .crumbs { display: flex; align-items: center; gap: 6px; min-width: 0; font-weight: 600; }
.topbar .crumbs .sep { color: var(--text-faint); }
.topbar .crumb { padding: 5px 9px; border-radius: 9px; cursor: pointer; color: var(--text-dim);
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 220px; }
.topbar .crumb:hover { background: var(--glass); color: var(--text); }
.topbar .crumb.current { color: var(--text); cursor: default; }
.topbar .spacer { flex: 1; }
.topbar-right { margin-left: auto; flex: none; }
.menu-toggle { display: none; }
@media (max-width: 820px) { .menu-toggle { display: inline-flex; } }

/* ── Avatar / présence ── */
.avatar {
  width: 34px; height: 34px; border-radius: 50%; display: grid; place-content: center;
  font-size: 13px; font-weight: 650; color: #fff; background: var(--coral); overflow: hidden;
  border: 1.5px solid var(--border-strong); flex: none; position: relative;
}
/* La photo de profil remplit tout le cercle ; pas de fond orange derrière une photo. */
.avatar img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; display: block; }
.avatar:has(img) { background: transparent; }
.avatar.sm { width: 26px; height: 26px; font-size: 11px; }
.presence { display: flex; align-items: center; }
.presence .avatar { margin-left: -8px; box-shadow: 0 0 0 2px var(--bg); }
.presence .avatar:first-child { margin-left: 0; }

/* ── Menu déroulant / contextuel ── */
.menu {
  position: fixed; z-index: 200; min-width: 210px; padding: 7px; border-radius: 16px;
  background: var(--glass-strong); border: 1px solid var(--border);
  -webkit-backdrop-filter: blur(26px) saturate(180%); backdrop-filter: blur(26px) saturate(180%);
  box-shadow: var(--shadow); animation: pop 0.16s var(--ease);
}
@keyframes pop { from { opacity: 0; transform: scale(0.96) translateY(-4px); } }
.menu-item { display: flex; align-items: center; gap: 11px; padding: 9px 11px; border-radius: 10px;
  font-size: 14px; color: var(--text); cursor: pointer; }
.menu-item:hover { background: var(--glass-hover); }
.menu-item svg { width: 17px; height: 17px; color: var(--text-dim); }
.menu-item.danger { color: #ff6b6b; } .menu-item.danger svg { color: #ff6b6b; }
.menu-sep { height: 1px; background: var(--border); margin: 6px 4px; }

/* ── Modale ── */
.modal-backdrop {
  position: fixed; inset: 0; z-index: 300; display: grid; place-items: center; padding: 20px;
  background: rgba(0,0,0,0.45); -webkit-backdrop-filter: blur(6px); backdrop-filter: blur(6px);
  animation: fadeIn 0.2s var(--ease);
}
.modal {
  width: min(480px, 100%); padding: 26px; border-radius: var(--r-lg);
  background: var(--glass-strong); border: 1px solid var(--border-strong);
  -webkit-backdrop-filter: blur(30px) saturate(180%); backdrop-filter: blur(30px) saturate(180%);
  box-shadow: var(--shadow); animation: pop 0.22s var(--ease);
}
.modal h3 { font-size: 19px; margin-bottom: 6px; }
.modal p.sub { color: var(--text-dim); font-size: 14px; margin: 0 0 18px; }
.modal .row { display: flex; gap: 10px; justify-content: flex-end; margin-top: 22px; }
.modal label { display: block; font-size: 13px; color: var(--text-dim); margin: 14px 0 6px; font-weight: 560; }

/* ── Toasts ── */
.toasts { position: fixed; bottom: 22px; left: 50%; transform: translateX(-50%); z-index: 400;
  display: flex; flex-direction: column; gap: 10px; align-items: center; }
.toast {
  display: flex; align-items: center; gap: 10px; padding: 12px 18px; border-radius: 99px;
  background: var(--glass-strong); border: 1px solid var(--border-strong); box-shadow: var(--shadow);
  -webkit-backdrop-filter: blur(24px) saturate(180%); backdrop-filter: blur(24px) saturate(180%);
  font-size: 14px; font-weight: 540; animation: toastIn 0.28s var(--ease);
}
.toast.err { color: #ff7a7a; }
.toast .dot { width: 8px; height: 8px; border-radius: 50%; background: var(--coral); }
@keyframes toastIn { from { opacity: 0; transform: translateY(12px); } }

/* ── Toggle thème ── */
.theme-toggle { position: relative; }
.theme-toggle svg { transition: transform 0.5s var(--ease), opacity 0.3s; }

/* ── États vides ── */
.empty { display: grid; place-items: center; text-align: center; gap: 8px; padding: 60px 20px;
  color: var(--text-dim); }
.empty .ico { width: 64px; height: 64px; border-radius: 20px; display: grid; place-items: center;
  background: var(--glass); border: 1px solid var(--border); margin-bottom: 6px; }
.empty .ico svg { width: 30px; height: 30px; color: var(--text-faint); }
.empty h3 { color: var(--text); font-weight: 620; }

/* Pastille de notification sur la nav (messages, partages) */
.nav-item { position: relative; }
.nav-badge { margin-left: auto; min-width: 19px; height: 19px; padding: 0 6px; border-radius: 99px; background: var(--coral);
  color: #fff; font-size: 11px; font-weight: 700; display: grid; place-items: center; box-shadow: 0 0 0 2px var(--bg); }
.shell.collapsed .nav-badge { position: absolute; top: 6px; right: 6px; margin: 0; min-width: 16px; height: 16px; font-size: 10px; }

/* Voile derrière le menu latéral (mobile) — clic pour fermer */
.sidebar-backdrop { display: none; }
@media (max-width: 820px) {
  .sidebar-backdrop { position: fixed; inset: 0; z-index: 55; background: rgba(0,0,0,.45);
    opacity: 0; pointer-events: none; transition: opacity .25s var(--ease);
    -webkit-backdrop-filter: blur(2px); backdrop-filter: blur(2px); display: block; }
  .shell.nav-open .sidebar-backdrop { opacity: 1; pointer-events: auto; }
}
